import $ from 'jquery'
window.$ = window.jQuery = $

// This should be removed once we're fully off of jQuery
// and on turbo, obvi.
$.ajaxPrefilter(function(options, _originalOptions, xhr) {
  if (!options.crossDomain) {
    const token = $("meta[name='csrf-token']").attr("content");
    if (token) xhr.setRequestHeader("X-CSRF-Token", token);
  }
});
